// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__27xtl","paramInput":"JobSimulator_paramInput__3IyIn","input":"JobSimulator_input__3xTtd"};